import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

function Footer() {
  return (
    <StaticQuery
      query={footerQuery}
      render={data => {
        const footer = data.allMarkdownRemark.edges.filter(item => item.node.fileAbsolutePath.indexOf('footer') >= 0)[0];

        return (
          <footer>
            <div className="social-links-container">
              <a className="social-links" href={footer.node.frontmatter.twitter} target="_blank" rel="noopener noreferrer">
                <Image
                  fixed={data.twitter.childImageSharp.fixed}
                  alt="twitter"
                />
              </a>
              <a className="social-links" href={footer.node.frontmatter.linkedin} target="_blank" rel="noopener noreferrer">
                <Image
                  fixed={data.linkedin.childImageSharp.fixed}
                  alt="linkedin"
                />
              </a>
            </div>
            <div dangerouslySetInnerHTML={{ __html: footer.node.html }} />
            <a className="mailto-link" href={`mailto: ${footer.node.frontmatter.email}`}>Email</a>
          </footer>
        )
      }}
    />
  )
}

export default Footer;

const footerQuery = graphql`
  query FooterQuery {
    twitter: file(absolutePath: { regex: "/twitter.png/" }) {
      childImageSharp {
        fixed(width: 22, height: 19) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    linkedin: file(absolutePath: { regex: "/linkedin.png/" }) {
      childImageSharp {
        fixed(width: 22, height: 22) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    allMarkdownRemark {
      edges {
        node {
          frontmatter {
            title
            description
            twitter
            linkedin
            email
          }
          fileAbsolutePath
          html
        }
      }
    }
  }
`